import React from 'react';
import styles from './beacon.module.scss';
import classnames from 'classnames';

type BeaconProps = {
  onMouseEnter?: () => void;
};

export const Beacon = ({ onMouseEnter = void 0 }: BeaconProps) => {
  return (
    <span
      data-testid="beacon"
      onMouseEnter={onMouseEnter}
      className={classnames(styles.beacon)}
    ></span>
  );
};
